import Vue from "vue";
import Vuex from "vuex";

import { UserInterfaceStore } from "./modules";

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  modules: {
    ui: UserInterfaceStore
  }
});

export default store;
